import { z } from 'zod'

const PERSON_NAME_REGEX = /^[\p{L}\p{M}' -]+$/u

export const firstNameSchema = z
	.string()
	.trim()
	.min(2, 'Must be at least 2 characters')
	.max(50, 'Must be 50 characters or fewer')
	.regex(PERSON_NAME_REGEX, 'Only letters, hyphens, apostrophes, and spaces are allowed')

export const lastNameSchema = z
	.string()
	.trim()
	.min(2, 'Must be at least 2 characters')
	.max(50, 'Must be 50 characters or fewer')
	.regex(PERSON_NAME_REGEX, 'Only letters, hyphens, apostrophes, and spaces are allowed')

export const fullNameSchema = z
	.string()
	.trim()
	.min(2, 'Must be at least 2 characters')
	.max(100, 'Must be 100 characters or fewer')
	.regex(PERSON_NAME_REGEX, 'Only letters, hyphens, apostrophes, and spaces are allowed')
